// extracted by mini-css-extract-plugin
export default {"root":"PrivacyPolicy_root__YxW+o","main":"PrivacyPolicy_main__e7ZmH","title":"PrivacyPolicy_title__24C1-","section":"PrivacyPolicy_section__I4Bq5"};